<template>
  <div
    class="mx-auto rounded-lg shadow-lg overflow-hidden mt-2 bg-vlight-paper px-6 py-8"
  >
    <h3
      class="text-3xl leading-8 font-semibold tracking-wider text-gray-900 font-bebas text-darkpurple"
    >
      {{ session.title }}
    </h3>
    <div class="max-w-lg lg:max-w-none lg:flex mt-2">
      <div class="  lg:flex-shrink-1 lg:w-2/3">
        <div class="mx-auto">
          <div class="mx-auto embed-container" v-if="replayReady">
            <iframe
              :src="session.youtubeEmbedURL"
              class="w-full"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
            <div v-if="false">
              <live-stream-player :session="session" />
            </div>
          </div>
          <img v-else :src="previewImage" />
        </div>

        <p class="mt-6 text-base leading-6 text-gray-500 prose">
          <standard-block-content
            :blocks="session.description"
          ></standard-block-content>
        </p>
        <div class="mt-8">
          <topic-grid :session="session"></topic-grid>
        </div>
        <div class="mt-10" v-if="hasTutorials">
          <tutorial-videos :session="session"></tutorial-videos>
        </div>
        <div class="mt-10">
          <session-compatibility-block
            :session="session"
          ></session-compatibility-block>
        </div>
        <div class="items-center mt-10">
          <div class="flex items-center">
            <h4
              class="flex-shrink-0 pr-4 font-bebas tracking-wider text-lg leading-5 tracking-wider uppercase text-gray-600"
            >
              Comments & Questions
            </h4>
            <div class="flex-1 border-t-2 border-green"></div>
          </div>
        </div>
        <session-comment-area :session="session"> </session-comment-area>
      </div>
      <div class="lg:w-1/3 px-4">
        <chat-box :session="session" :allow-chat="false"></chat-box>
      </div>
    </div>
  </div>
</template>

<script>
import SessionCompatibilityBlock from "./SessionCompatibilityBlock";
import TopicGrid from "./TopicGrid";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import SessionCommentArea from "./SessionCommentArea";
import LiveStreamPlayer from "./LiveStreamPlayer";
import ChatBox from "./ChatBox";
import StandardBlockContent from "./StandardBlockContent";
import TutorialVideos from "./TutorialVideos";

export default {
  name: "PreviousSessionPage",
  components: {
    TutorialVideos,
    ChatBox,
    LiveStreamPlayer,
    SessionCompatibilityBlock,
    SessionCommentArea,
    TopicGrid,
    StandardBlockContent
  },
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    replayReady() {
      return (
        this.session.youtubeEmbedURL && this.session.youtubeEmbedURL.length > 0
      );
    },
    hasTutorials() {
      const tutorials = this.session.tutorials || [];
      return tutorials.length > 0;
    },
    previewImage() {
      return sanityImageBuilder
        .image(this.session.previewImage)
        .width(400)
        .url();
    },
  }
};
</script>
<style scoped>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
